import {TLabelProps} from "@/app/[locale]/common/components/Label/types";
import s from './Label.module.scss';

export const Label = ({ size = 'desktop',  children }: TLabelProps) => {
    return (
        <label className={`${s.label} ${s[size]}`}>
            { children }
        </label>
    );
};